import Vue from 'vue'

export async function openInsuranceFlow(parent, source, insuranceProductCode) {
  const { default: InsuranceFlow } = await import('@/views/insurance/preview.vue')
  if (parent._isDestroyed || parent._isBeingDestroyed) return false

  // 保留原进件页及本次返回结果；用户选择老流程后继续原分发，避免再次进件。
  return new Promise((resolve) => {
    let settled = false
    let cleaned = false
    let continuing = false
    let removeRouteHook
    const unwatch = []
    const cleanup = () => {
      if (cleaned) return
      cleaned = true
      parent.$off('hook:beforeDestroy', cancel)
      unwatch.forEach((stop) => stop())
      if (removeRouteHook) removeRouteHook()
      window.removeEventListener('pagehide', cancel)
      view.$destroy()
      view.$el.remove()
    }
    const finish = (resume) => {
      if (settled) return
      settled = true
      if (resume === true) {
        // 先让旧分发继续执行，但保留过渡层，覆盖接口等待与原有延迟跳转期间的进件底页。
        continuing = true
        view.continuing = true
      } else cleanup()
      resolve(resume)
    }
    const cancel = () => {
      cleanup()
      if (!settled) {
        settled = true
        resolve(false)
      }
    }
    const view = new Vue({
      parent,
      data: () => ({ continuing: false }),
      render(h) {
        return h(
          'div',
          {
            style: {
              position: 'fixed',
              inset: '0',
              zIndex: 1000,
              overflowY: 'auto',
              background: '#fff',
            },
          },
          this.continuing
            ? [
                h(
                  'div',
                  {
                    attrs: { role: 'status', 'aria-live': 'polite' },
                    style: {
                      minHeight: '100vh',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#969aa2',
                      fontSize: '14px',
                    },
                  },
                  [
                    h(
                      'van-loading',
                      { props: { color: '#fd6f34', vertical: true } },
                      '正在进入下一步…'
                    ),
                  ]
                ),
              ]
            : [
                h(InsuranceFlow, {
                  props: { isPreview: false, source, insuranceProductCode },
                  on: {
                    continue: () => finish(true),
                    insured: (insuranceResult) => finish({ insuranceResult }),
                  },
                }),
              ]
        )
      },
    }).$mount()
    // 留页推荐或换品协议先完成渲染再交接；整页跳转保留遮罩到pagehide，站内跳转在路由更新后清理。
    unwatch.push(
      parent.$watch(
        () => parent.incomingShow || parent.showProductsPop,
        (visible) => {
          if (continuing && visible) parent.$nextTick(cleanup)
        }
      )
    )
    unwatch.push(
      parent.$watch(
        () => parent.sendData,
        (data) => {
          // 进入保险页时已关闭原协议；旧分支取得CPA产品二后恢复原协议，避免过渡层无人接手。
          if (continuing && parent.isCpaProductTwo && data && data.productId) {
            parent.openAgreementPopup()
            parent.$nextTick(cleanup)
          }
        }
      )
    )
    if (parent.$router)
      removeRouteHook = parent.$router.afterEach(() => {
        if (continuing) parent.$nextTick(cleanup)
      })
    parent.$once('hook:beforeDestroy', cancel)
    window.addEventListener('pagehide', cancel)
    document.body.appendChild(view.$el)
  })
}
